var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("商品比价列表")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right",
            on: {
              click: function($event) {
                _vm.$router.back(-1)
              }
            }
          },
          [_vm._m(0)]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tab-container small base mt20" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c(
          "ul",
          { staticClass: "head" },
          _vm._l(_vm.comparisonTypeList, function(text, value) {
            return _c(
              "li",
              {
                staticClass: "head-item",
                class: { current: value == _vm.checkStateValue },
                on: {
                  click: function($event) {
                    _vm.changeStatue(value)
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(text))])]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs-content", staticStyle: { "min-height": "735px" } },
        [
          _c("ul", { staticClass: "body" }, [
            _c("li", { staticClass: "body-item" }, [
              _vm.checkStateValue == 0
                ? _c("div", {}, [
                    _c(
                      "div",
                      {
                        staticClass: "mb10",
                        staticStyle: { border: "1px solid #dadada" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-row pos-rel",
                            staticStyle: { "padding-right": "100px" }
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-value width-1x" },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.priceInqryGoods.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.priceInqryGoods, "name", $$v)
                                    },
                                    expression: "priceInqryGoods.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _c("span", [_vm._v(_vm._s(_vm.skuId))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(" ")])
                            ]),
                            _vm._v(" "),
                            _vm._m(3),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              !_vm.priceInqryGoods.priceNegoFlag
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.priceInqryGoods.price) + "元"
                                    )
                                  ])
                                : _c("span", [_vm._v("面议")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(" ")])
                            ]),
                            _vm._v(" "),
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _vm.priceInqryGoods.wrntPeriod != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.priceInqryGoods.wrntPeriod) +
                                        "月"
                                    )
                                  ])
                                : _c("span", [_vm._v(" ")])
                            ]),
                            _vm._v(" "),
                            _vm._m(5),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.priceInqryGoods.unit) +
                                  "\n                                    "
                              ),
                              _c("span", [_vm._v(" ")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "pos-abs",
                                staticStyle: { top: "0", right: "25px" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "swb-btn swb-btn-small",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.searchName(true)
                                      }
                                    }
                                  },
                                  [_vm._v("搜索")]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-layout" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.priceReplyGoodsList, border: "" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "inqryNo",
                                label: "询价单号",
                                align: "left",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.toPriceInpryList(
                                                rows.row.inqryNo
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(rows.row.inqryNo))]
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "商品名称",
                                align: "left",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuId",
                                label: "SKUID",
                                align: "right",
                                width: "100",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "呈报单价(元)",
                                sortable: "",
                                align: "right",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              rows.row.replyPrice
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "replyWrntPeriod",
                                label: "呈报质保期(月)",
                                sortable: "",
                                align: "right",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "unit",
                                label: "单位",
                                align: "left",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "desc",
                                label: "说明",
                                align: "center",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "merchantName",
                                label: "报价方名称",
                                align: "left",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "replyTime",
                                label: "报价时间",
                                sortable: "",
                                align: "center",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "expireDate",
                                label: "截止日期",
                                sortable: "",
                                align: "center",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "adopted",
                                label: "是否采纳",
                                align: "center",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.adopted
                                        ? _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                "background-color":
                                                  "transparent",
                                                border: "none"
                                              },
                                              attrs: {
                                                type: "success",
                                                "close-transition": ""
                                              }
                                            },
                                            [_c("span", [_vm._v("是")])]
                                          )
                                        : _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                "background-color":
                                                  "transparent",
                                                border: "none"
                                              },
                                              attrs: {
                                                type: "danger",
                                                "close-transition": ""
                                              }
                                            },
                                            [_vm._v("否")]
                                          )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "block pagination-layout" },
                      [
                        _c("el-pagination", {
                          staticClass: "mt10",
                          attrs: {
                            background: "",
                            "page-size": _vm.pageSize,
                            "page-sizes": _vm.pageSizes,
                            "current-page": _vm.pageNumber,
                            total: _vm.totalCount,
                            layout: "total, sizes, prev, pager, next, jumper"
                          },
                          on: {
                            "current-change": _vm.handlePageChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.checkStateValue == 1
                ? _c("div", {}, [
                    _c(
                      "div",
                      {
                        staticClass: "content-subtitle",
                        staticStyle: { border: "1px solid #dadada" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-row pos-rel",
                            staticStyle: { "padding-right": "100px" }
                          },
                          [
                            _vm._m(6),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-value" },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.name,
                                    callback: function($$v) {
                                      _vm.name = $$v
                                    },
                                    expression: "name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(7),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _c("span", [_vm._v(_vm._s(_vm.skuId))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(" ")])
                            ]),
                            _vm._v(" "),
                            _vm._m(8),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.bidGoods.price) + "元")
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._m(9),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _vm.bidGoods.wrntPeriod != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.bidGoods.wrntPeriod) + "月"
                                    )
                                  ])
                                : _c("span", [_vm._v(" ")])
                            ]),
                            _vm._v(" "),
                            _vm._m(10),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-value" }, [
                              _c("span", [_vm._v(_vm._s(_vm.bidGoods.unit))])
                            ]),
                            _vm._v(" "),
                            _vm._m(11),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "pos-abs",
                                staticStyle: { top: "0", right: "25px" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "swb-btn swb-btn-small",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.searchName(true)
                                      }
                                    }
                                  },
                                  [_vm._v("搜索")]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-layout" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.bidGoodsList, border: "" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "callDocNo",
                                label: "招标单号",
                                align: "left",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.toCallbidList(
                                                rows.row.callDocNo
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(rows.row.callDocNo))]
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "商品名称",
                                align: "left",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuId",
                                label: "SKUID",
                                align: "right",
                                width: "100",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "单价(元)",
                                sortable: "",
                                align: "right",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(rows.row.price).toFixed(
                                              2
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "wrntPeriod",
                                label: "质保期(月)",
                                sortable: "",
                                align: "right",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "unit",
                                label: "单位",
                                align: "left",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "desc",
                                label: "说明",
                                align: "center",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "merchantName",
                                label: "投标方名称",
                                align: "left",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "bidTime",
                                label: "投标时间",
                                sortable: "",
                                align: "center",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "resultPublishTime",
                                label: "公布时间",
                                sortable: "",
                                align: "center",
                                "show-overflow-tooltip": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "resultFlag",
                                label: "中标状态",
                                align: "center",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.resultFlag == 0
                                        ? _c("span", [_vm._v("未中标")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      rows.row.resultFlag == 1
                                        ? _c("span", [_vm._v("已中标")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      rows.row.resultFlag == -1
                                        ? _c("span", [_vm._v("已流标")])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "block pagination-layout" },
                      [
                        _c("el-pagination", {
                          staticClass: "mt10",
                          attrs: {
                            background: "",
                            "page-size": _vm.pageSize,
                            "page-sizes": _vm.pageSizes,
                            "current-page": _vm.pageNumber,
                            total: _vm.totalCount,
                            layout: "total, sizes, prev, pager, next, jumper"
                          },
                          on: {
                            "current-change": _vm.handlePageChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品名称:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品skuId:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品单价")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品质保期:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品单位:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品名称:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品skuId:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品单价")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品质保期:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前比价商品单位:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v(" ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-651c1801", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-651c1801","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/priceInpry/PriceComparison.vue
// module id = 3283
// module chunks = 0